import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getFolderTree } from "../api/folders.api";
import { breadcrumbFromIndex, useFolderIndex } from "./useFolderIndex";
import type { BreadcrumbItem } from "@titancloud/shared";

export function useFolderTree(folderId: string | null): BreadcrumbItem[] {
  const { index, isPending } = useFolderIndex();
  const fromIndex = useMemo(
    () => (folderId && index ? breadcrumbFromIndex(index, folderId) : null),
    [folderId, index]
  );

  // Only asks the server when the cached folder tree cannot answer.
  const query = useQuery({
    queryKey: ["folder-tree", folderId],
    queryFn: () => getFolderTree(folderId!),
    enabled: !!folderId && !isPending && !fromIndex,
  });

  return fromIndex ?? query.data ?? [];
}
